import React, { useEffect, useState } from 'react';
import { AppDispatch, RootState } from '../../state/store';
import { useDispatch, useSelector } from 'react-redux';
import { WizardButtonGroup } from '../wizard/wizard-button-group-component';

import styles from './driver-vehicle.module.css';
import { BaseWizardProps } from '../wizard/wizard-step-base';
import { GoACallout, GoASpacer } from '@abgov/react-components';
import {
  getLoginInfoFromKeycloakJwt,
  isTheAccountVerifiedByGoA,
} from '../../state/slices/authSlice';

function renderVerifiedUserContent() {
  return (
    <div>
      <p>
        Provide personal, vehicle, and insurance details. To ensure accuracy,
        you may want to have your Driver’s licence, vehicle registration
        certificate, and insurance certificate handy.
      </p>
      <GoASpacer vSpacing="l" />
      <h4>Sections to fill out include:</h4>
      <ul className="goa-unordered-list">
        <li>Personal and contact information</li>
        <li>
          Vehicle details and owner information (if different from the driver)
        </li>
        <li>Insurance information</li>
      </ul>
    </div>
  );
}

function renderBasicUserContent() {
  return (
    <div>
      <p>Please review the important information below.</p>
      <GoASpacer vSpacing="l" />
      <GoACallout
        heading="You must have a verified Alberta.ca account to continue."
        type="information"
      >
        Click below to save your progress and verify your account.
      </GoACallout>
    </div>
  );
}

export interface DriverVehicleIntroductionComponentProps
  extends BaseWizardProps {}
export const DriverVehicleIntroductionComponent = ({
  navigationConfiguration,
}: DriverVehicleIntroductionComponentProps) => {
  const useAppSelector: <TSelected>(
    selector: (state: RootState) => TSelected,
  ) => TSelected = useSelector;

  const stateAuth = useAppSelector((state: RootState) => state.auth);

  useEffect(() => {
    const pageConfig = navigationConfiguration.pagingConfiguration.find(
      (item) => item.default !== undefined,
    );

    setNextPage(pageConfig?.default ?? 'error');
  }, []);

  const isBasicAccount = () => {
    let isBasic = true;
    if (stateAuth.auth.access.access) {
      const info = getLoginInfoFromKeycloakJwt(stateAuth.auth.access.access);
      isBasic = !isTheAccountVerifiedByGoA(info.albertaVerified);
      return isBasic;
    }
    return isBasic;
  };

  const [nextPage, setNextPage] = useState('');
  const [showVerificationRequired, setShowVerificationRequired] =
    useState<boolean>(() =>
      stateAuth.auth.access?.access ? isBasicAccount() : false,
    );

  const save = () => {
    if (navigationConfiguration.save) {
      navigationConfiguration.save();
    }
  };

  return (
    <div>
      <h1>Driver and vehicle information</h1>
      <GoASpacer vSpacing={'m'} />

      {showVerificationRequired
        ? renderBasicUserContent()
        : renderVerifiedUserContent()}

      <div>
        <WizardButtonGroup
          buttonText={showVerificationRequired ? '' : 'Get started'}
          nextPage={nextPage}
          goToReview={navigationConfiguration.goToReview}
          save={save}
          navigate={navigationConfiguration.navigate}
          showVerifyUserButton={showVerificationRequired}
        />
      </div>
    </div>
  );
};
